export type DBPersistedMyRunsConfig = {
  myRunsExperimentRegex?: string;
};

export const DB_PERSISTED_MY_RUNS_CONFIG_KEY: keyof DBPersistedMyRunsConfig =
  'myRunsExperimentRegex';
